import React, { useState } from "react";
import { Tabs, TabHeader, TabPanel, ButtonField, Iconsvg } from "@wk/components-react16";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import HttpService from "../../config/http.service";
import { API_USER } from "../../config/constants";
import UserAccessOverview from "./UserAccessOverview";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../store/authReducer";
import { RootState } from "../../store";
import { Privilege } from "../../config/constants/privilege";
import ExportUserActionLog from "./modal/ExportUserActionLog";

const UserTab = ({ data }: any) => {
  const { authUser, } = useSelector((state: RootState) => state.auth);
  const { roleList, projectList } = data;
   const [triggerGetUser, setTriggerGetUser] = useState(false);
   const [triggerGetUserList, setTriggerGetUserList] = useState(false);
   const [selectedUser, setSelectedUser] = useState(null as any);
   const [selectedTab, setSelectedTab] = useState(0);
   const [isExportUserActionLog, setIsExportUserActionLog] = useState(false);
   const dispatch = useDispatch();
  const handleExport = async () => {
    try {
      dispatch(showLoading());
      const response: any = await HttpService.getRequestBlob(
        API_USER.EXPORT_USERS
      );

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "AllUsers.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      console.error("Export error:", err);
      alert("Export failed, check console for details");
    }

  };

  const editUser = (data:any) => {
    handleTabChange(1);
    setSelectedUser(data);
    setTriggerGetUser(prev => !prev);
  };

  const handleTabChange = (index: number) => {
        setSelectedTab(index);
        if (index === 2) {
            setTriggerGetUserList(true);
        } else {
            setTriggerGetUserList(false);
        }
    };

  return (
    <div className="p-10 pb-20 wk-card-container mb-0 rounded-3 box-shadow">
      <div className="wk-col-12 text-right">
        <ButtonField iconPosition={'left'} mode={'text'}>
          <button type="button" onClick={() => setIsExportUserActionLog(true)}>
            <Iconsvg name="download-line"></Iconsvg>
            Export User Action Log
          </button>
        </ButtonField>
        
        <ButtonField iconPosition={'left'} mode={'text'}>
          <button type="button" onClick={handleExport}>
            <Iconsvg name="download-line"></Iconsvg>
            Export User List
          </button>
        </ButtonField>
      </div>

      <Tabs mode="default" 
        controlMode="controlled" 
        selectedTab={selectedTab}
        onUserRequest={(event: any) => handleTabChange(event)}>
        <TabHeader slot="tabHeader">Add User</TabHeader>
        <TabHeader slot="tabHeader">Edit User</TabHeader>
        {authUser?.privileges.includes(Privilege[Privilege.USER_ACCESS_OVERVIEW]) && (
          <TabHeader slot="tabHeader">User Access Overview</TabHeader>
        )}

        <TabPanel slot="tabPanel">
          <AddUser data={{ roleList, projectList: projectList?.map((item: any) => ({ ...item })) }} />
        </TabPanel>
        <TabPanel slot="tabPanel">
          <EditUser data={{ roleList, projectList: projectList?.map((item: any) => ({ ...item })), triggerGetUser, selectedUser }} />
        </TabPanel>
        {authUser?.privileges.includes(Privilege[Privilege.USER_ACCESS_OVERVIEW]) && (
          <TabPanel slot="tabPanel">
          <UserAccessOverview data={{ roleList, projectList: projectList?.map((item: any) => ({ ...item })) }} editUser={editUser} triggerGetUserList={triggerGetUserList} />
        </TabPanel>
        )}
      </Tabs>
      <ExportUserActionLog isExportUserActionLog={isExportUserActionLog} setIsExportUserActionLog={setIsExportUserActionLog} />
    </div>
  );
};

export default UserTab;
